import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';

// Guest email edit dialog. Only reachable for guests — server
// re-validates and hard-rejects registered users with 403.
export default function GuestEmailEditDialog({
  open, setOpen, hasExistingEmail, emailDraft, setEmailDraft, savingEmail, onSave,
}) {
  return (
    <Dialog
      open={open}
      onOpenChange={(o) => { if (!o && !savingEmail) setOpen(false); }}
    >
      <DialogContent data-testid="guest-email-edit-dialog">
        <DialogHeader>
          <DialogTitle>
            {hasExistingEmail ? 'Edit guest email' : 'Add guest email'}
          </DialogTitle>
        </DialogHeader>
        <div className="space-y-4">
          <p className="text-sm text-muted-foreground">
            Only the email is editable. Name and phone stay fixed to match
            the guest&apos;s original booking.
          </p>
          <p className="text-xs text-amber-700 bg-amber-50 border border-amber-200 rounded-md px-3 py-2">
            <strong>Note:</strong> This updates how the guest appears in Customer
            Management. Confirmation emails and calendar invites still use the
            email captured at booking time.
          </p>
          <div>
            <Label htmlFor="guest-email-input" className="text-xs uppercase font-bold text-muted-foreground mb-1 block">
              Email
            </Label>
            <Input
              id="guest-email-input"
              type="email"
              value={emailDraft}
              onChange={(e) => setEmailDraft(e.target.value)}
              placeholder="guest@example.com"
              disabled={savingEmail}
              data-testid="guest-email-input"
              autoFocus
            />
          </div>
          <div className="flex justify-end gap-2 pt-2">
            <Button
              type="button"
              variant="outline"
              onClick={() => setOpen(false)}
              disabled={savingEmail}
              data-testid="guest-email-cancel-btn"
            >
              Cancel
            </Button>
            <Button
              type="button"
              onClick={onSave}
              disabled={savingEmail}
              data-testid="guest-email-save-btn"
            >
              {savingEmail ? 'Saving…' : 'Save'}
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
